import { axios } from '@/utils/request'

async function postData(url, data = {}) {
  try {
    return await axios({ url, method: 'post', data })
  } catch (ex) {
    return ex
  }
}

export function getUserDepartInfo(data) {
  return postData('/ucs-auth/tenant-user/getUserDepartInfo', data)
}

export function getMenus(data) {
  return postData('/ucs-auth/index/common-function/get-menus', data)
}

export function getCommonFunctions(data) {
  return postData('/ucs-auth/index/common-function/get-common-functions', data)
}

export function updateCommonFunctions(data) {
  return postData('/ucs-auth/index/common-function/update-common-functions', data)
}

export function deleteCommonFunctions(id) {
  return postData('/ucs-auth/index/common-function/delete-common-functions?id=' + id)
}

export function getTodo(data) {
  return postData('/ucs-auth/index/to-do/get-todo', data)
}
